<script lang="ts" setup>
</script>

<template>
  <svg
    width="177"
    height="24"
    viewBox="0 0 177 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="168.5"
      cy="12"
      r="8"
      fill="#D7D8DB"
    />
    <rect
      x="4.5"
      y="11"
      width="160"
      height="2"
      fill="#D7D8DB"
    />
    <rect
      x="4.5"
      y="11"
      width="84"
      height="2"
      fill="#7B90FF"
    />
    <circle
      cx="88.5"
      cy="12"
      r="12"
      fill="#7B90FF"
    />
    <circle
      cx="88.5"
      cy="12"
      r="11.5"
      fill="#FAFAFB"
      stroke="#7B90FF"
    />
    <circle
      cx="88.5"
      cy="12"
      r="4.61538"
      fill="#7B90FF"
    />
    <circle
      cx="8.5"
      cy="12"
      r="8"
      fill="#7B90FF"
    />
    <path
      d="M5.5 11.6552L7.72857 14L11.5 10"
      stroke="white"
      stroke-width="2"
    />
  </svg>
</template>

<style lang="scss" scoped>
</style>
